module.exports = __webpack_public_path__ + "img/pic5.7933ce28.png";